import {
  AnyAction,
  createListenerMiddleware,
  isAnyOf,
  ListenerMiddlewareInstance,
  ThunkDispatch,
  UnsubscribeListener,
} from '@reduxjs/toolkit';

import { AppRootState } from '../../../store/models/app-state.model';
import { FirmwareFilterListenerEffect } from '../effects/firmware-filter-listener.effect';
import {
  filterFirmwaresByBrand,
  filterFirmwaresByEcus,
  filterFirmwaresByModel,
  filterFirmwaresByPlatform,
} from '../store/slices/firmware.slice';

export const firmwareFilterListener: ListenerMiddlewareInstance<
  AppRootState,
  ThunkDispatch<AppRootState, undefined, AnyAction>
> = createListenerMiddleware();

export const unsubscribeFirmwareFilterListener: UnsubscribeListener =
  firmwareFilterListener.startListening({
    matcher: isAnyOf(
      filterFirmwaresByModel,
      filterFirmwaresByBrand,
      filterFirmwaresByEcus,
      filterFirmwaresByPlatform
    ),
    effect: FirmwareFilterListenerEffect,
  });
